import React from "react";
import StandardModal from "@/js/components/shared/StandardModal";
import Checkbox from "../shared/Checkbox";

interface Props {
	open: boolean;
	onClose: () => void;
	onSubmit: () => void;
	disableChatEnableModal: boolean;
	handleCheckbox: (checked: boolean) => void;
}

const ChatEnableModal = ({ open, onClose, onSubmit, disableChatEnableModal, handleCheckbox }: Props): JSX.Element => (
	<StandardModal size="small" header={<div className="ChatEnableModal_title">Heads up!</div>} open={open} close={onClose}>
		<div className="ChatEnableModal_text">Chat automatically turns off when a class session ends.</div>
		<div className="ChatEnableModal_checkbox">
			<Checkbox checked={disableChatEnableModal} label="Don't show me this message again" onChecked={handleCheckbox} />
		</div>
		<button className="ChatEnableModal_button" type="button" onClick={onSubmit}>
			I understand
		</button>
	</StandardModal>
);

export default ChatEnableModal;
